import { render, staticRenderFns } from "./LocalListItem.vue?vue&type=template&id=6fb10275&scoped=true"
import script from "./LocalListItem.vue?vue&type=script&lang=js"
export * from "./LocalListItem.vue?vue&type=script&lang=js"
import style0 from "./LocalListItem.vue?vue&type=style&index=0&id=6fb10275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb10275",
  null
  
)

export default component.exports